
import utils from '@/utils';
import { defineComponent } from 'vue';
import { ICloud } from '@/types/models';
import api, { IAddRequest, ICloudProductCount, IEditRequest, IGetRequest } from '@/api/admin/clouds';
import { IElForm } from '@/types/element';
import { CloudType } from '@/types/enums';

interface IState {
  count: number;
  clouds: ICloud[];
  cloud: ICloud;
  formInline: IGetRequest;
  isCount: boolean;
  counts: ICloudProductCount[];
  colors: { color: string; percentage: number }[];
  isAdd: boolean;
  addForm: IAddRequest;
  isEdit: boolean;
  editForm: IEditRequest;
}

export default defineComponent({
  data() {
    return {
      count: 0,
      clouds: [],
      cloud: {} as ICloud,
      formInline: {
        cloudType: '',
        currentPage: 1,
        offset: 0,
        limit: 30,
        dateFrom: '',
        dateTo: '',
        orderByIdDesc: false,
      } as IGetRequest,
      isCount: false,
      counts: [],
      colors: [
        { color: '#5cb87a', percentage: 30 },
        { color: '#1989fa', percentage: 50 },
        { color: '#6f7ad3', percentage: 65 },
        { color: '#e6a23c', percentage: 80 },
        { color: '#f56c6c', percentage: 100 },
      ],
      isAdd: false,
      addForm: {} as IAddRequest,
      isEdit: false,
      editForm: {} as IEditRequest,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.clouds = res.clouds;
      });
    },

    getCloudType(cloud: ICloud) {
      return utils.getCloudType(cloud.cloudType);
    },

    getCloudProduct(product: string) {
      return utils.getCloudProduct(product);
    },

    isExpiration(cloud: ICloud): boolean {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      const expirationDate = new Date(cloud.expirationDate);
      return expirationDate.getTime() <= date.getTime();
    },

    btnCloudClick(cloud: ICloud) {
      this.cloud = cloud;
    },

    btnDeleteClick(cloud: ICloud) {
      utils.alertDelete(
        {
          title: '删除云助手',
          text: `此操作将删除云助手 ${cloud.userName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(cloud.userId, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('云助手删除成功');
          });
        },
      );
    },

    btnSearchClick() {
      this.apiGet();
    },

    btnAddClick() {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth();
      const day = d.getDate();
      const expirationDate = new Date(year + 1, month, day);
      this.addForm = {
        userName: '',
        cloudType: CloudType.Free,
        expirationDate,
      } as IAddRequest;
      this.isAdd = true;
    },

    btnAddSubmitClick() {
      (this.$refs.addForm as IElForm).validate((valid) => {
        if (valid) {
          api.add(this.addForm, (res) => {
            if (!res) return;
            this.isAdd = false;
            this.apiGet();
            utils.success('云助手添加成功');
          });
        }
      });
    },

    btnCountClick(cloud: ICloud) {
      this.cloud = { ...cloud };
      api.count(
        {
          userId: this.cloud.userId,
        },
        (res) => {
          if (!res) return;

          this.counts = res.counts;
          this.isCount = true;
        },
      );
    },

    btnEditClick(cloud: ICloud) {
      this.cloud = { ...cloud };
      this.editForm = {
        userId: this.cloud.userId,
        expirationDate: this.cloud.expirationDate,
      } as IEditRequest;
      this.isEdit = true;
    },

    btnEditSubmitClick() {
      (this.$refs.editForm as IElForm).validate((valid) => {
        if (valid) {
          api.edit(this.editForm, (res) => {
            if (!res) return;
            this.isEdit = false;
            this.apiGet();
            utils.success('云助手修改成功');
          });
        }
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.clouds = res.clouds;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
